// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-page-wrapper {
   overflow: auto;
   height: calc(100vh - 60px);
   height: calc(100dvh - 60px)
}

.ecl-page-wrapper .page-content-container {
   padding: var(--padding); 
   width: 100%;
   height: 100%;
   overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/ECLPageWrapper.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,0BAA0B;GAC1B;AACH;;AAEA;GACG,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,cAAc;AACjB","sourcesContent":[".ecl-page-wrapper {\r\n   overflow: auto;\r\n   height: calc(100vh - 60px);\r\n   height: calc(100dvh - 60px)\r\n}\r\n\r\n.ecl-page-wrapper .page-content-container {\r\n   padding: var(--padding); \r\n   width: 100%;\r\n   height: 100%;\r\n   overflow: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
